import { FormFieldSchema } from 'app/shared/models/form';
import { U21FormFieldTypes } from 'app/shared/u21-ui/components';
import { required } from 'app/shared/utils/validation';

// Constants
import { T_PERSON_REGISTRATION_RAW_INPUTS_SCHEMA } from 'app/modules/goAML/schemas/tPersonRegistrationSchema';
import { T_LOCATION_SCHEMA } from 'app/modules/goAML/schemas/tLocationSchema';
import { SUBMISSION_TYPE_OPTIONS } from 'app/modules/goAML/schemas/catalogues/submissionType';
import { REPORT_CODE_OPTIONS } from 'app/modules/goAML/schemas/catalogues/reportType';
import { CURRENCY_CODE_OPTIONS } from 'app/modules/goAML/schemas/catalogues/currencyCodes';

export const RENTITY_ID_FIELD: FormFieldSchema<string> = {
  label: 'Reporting entity ID',
  name: 'content.report.rentity_id',
  required: true,
  type: U21FormFieldTypes.TEXT,
  validate: required('Reporting entity ID is required.'),
};

export const RENTITY_BRANCH_FIELD: FormFieldSchema<string> = {
  label: 'Reporting entity branch',
  name: 'content.report.rentity_branch',
  required: true,
  type: U21FormFieldTypes.TEXT,
  validate: required('Reporting entity branch is required.'),
};

export const SUBMISSION_CODE_FIELD: FormFieldSchema<string> = {
  label: 'Submission code',
  name: 'content.report.submission_code',
  required: true,
  type: U21FormFieldTypes.SELECT,
  fieldProps: {
    disabled: true,
    options: SUBMISSION_TYPE_OPTIONS,
  },
  default: 'E',
  validate: required('Submission code is required.'),
};

export const REPORT_CODE_FIELD: FormFieldSchema<string> = {
  label: 'Report code',
  name: 'content.report.report_code',
  required: true,
  type: U21FormFieldTypes.SELECT,
  fieldProps: {
    disabled: true,
    options: REPORT_CODE_OPTIONS,
  },
  default: 'STR',
  validate: required('Report code required.'),
};

export const ENTITY_REFERENCE_FIELD: FormFieldSchema<string> = {
  label: 'Entity reference',
  name: 'content.report.entity_reference',
  required: true,
  type: U21FormFieldTypes.TEXT,
  validate: required('Entity reference is required.'),
};

export const FIU_REFERENCE_FIELD: FormFieldSchema<string> = {
  label: 'FIU reference',
  name: 'content.report.fiu_ref_number',
  type: U21FormFieldTypes.TEXT,
};

export const SUBMISSION_DATE_FIELD: FormFieldSchema<Date> = {
  label: 'Submission date',
  name: 'content.report.submission_date',
  required: true,
  type: U21FormFieldTypes.DATE_PICKER,
  validate: required('Submission date is required.'),
  default: (filing) => {
    const submissionDate = filing.content?.report?.submission_date;
    return submissionDate ? new Date(submissionDate) : new Date();
  },
};

export const CURRENCY_CODE_LOCAL_FIELD: FormFieldSchema<string> = {
  label: 'Local currency code',
  name: 'content.report.currency_code_local',
  required: true,
  type: U21FormFieldTypes.SELECT,
  fieldProps: {
    options: CURRENCY_CODE_OPTIONS,
  },
  validate: required('Currency Code is required.'),
};

export const REASON_FIELD: FormFieldSchema<string> = {
  label: 'Reason',
  name: 'content.report.reason',
  type: U21FormFieldTypes.TEXTAREA,
};

export const ACTION_FIELD: FormFieldSchema<string> = {
  label: 'Actions taken',
  name: 'content.report.action',
  type: U21FormFieldTypes.TEXTAREA,
};

/** Reporting Person */
export const REPORTING_PERSON_SCHEMA =
  T_PERSON_REGISTRATION_RAW_INPUTS_SCHEMA.map((field) => ({
    ...field,
    name: `content.report.reporting_person.${field.name}`,
  }));

/** Location */
export const REPORTING_LOCATION_SCHEMA = [
  RENTITY_ID_FIELD,
  RENTITY_BRANCH_FIELD,
  ENTITY_REFERENCE_FIELD,
  CURRENCY_CODE_LOCAL_FIELD,
  ...T_LOCATION_SCHEMA.map((field) => ({
    ...field,
    name: `content.report.location.${field.name}`,
  })),
];

export const REPORTER_DATA_RAW_INPUTS = [
  SUBMISSION_CODE_FIELD,
  REPORT_CODE_FIELD,
  FIU_REFERENCE_FIELD,
  SUBMISSION_DATE_FIELD,
  REASON_FIELD,
  ACTION_FIELD,
];

export const REPORTER_DATA_SCHEMA = [
  ...REPORTER_DATA_RAW_INPUTS,
  ...REPORTING_PERSON_SCHEMA,
  ...REPORTING_LOCATION_SCHEMA,
];
